import React from 'react'
import PropTypes from 'prop-types'
import { Link, SecondaryButton } from '@aok/ui-elements'
import { ArrowRoundedRightup, Close } from '@aok/icon-functional'

const DesktopMenu = ({ fixedLinks, mainMenu, tags, onCloseButtonClick }) => {
  return (
    <div data-tracking-name="desktop-menu" className="shadow-header">
      <div
        className="
          pt-24 pb-80
          mx-24 1000:mx-32 1280:w-1216 1280:mx-auto
          border-t-2 border-dfe3e6
        "
      >
        {/* Close button */}
        <button className="block ml-auto mr-0" onClick={onCloseButtonClick}>
          <span className="sr-only">Ausgeklapptes Themenmenü schließen</span>
          <Close className="w-20 h-20 fill-current text-005e3f transition-transform duration-350 ease-in hover:scale-120" />
        </button>

        <div className="mt-48 grid grid-cols-12 gap-24 1000:gap-32">
          {/* Main menu */}
          <ul className="col-span-8 grid grid-cols-2 gap-x-24 1000:gap-x-32">
            {mainMenu.map((item, index) => (
              <li key={index} className="relative group">
                <a
                  href={item.url}
                  className="mainMenuItem block
                  px-8 pt-18 pb-16
                  text-16 leading-24 text-293033
                  group-hover:font-semibold focus:font-semibold
                  group-hover:text-005e3f focus:text-005e3f
                  after:focus:bg-left
                "
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>

          <div className="col-span-4">
            {/* Tags */}
            <p className="text-6d767c">Aktuelle Themen</p>
            <div className="flex flex-wrap -ml-16">
              {tags.map((tag, index) => (
                <SecondaryButton key={index} url={tag.url} className="mt-16 ml-16">
                  {tag.title}
                </SecondaryButton>
              ))}
            </div>

            {/* Link to Frontpage */}
            <Link
              href={fixedLinks?.start?.url}
              title={fixedLinks?.start?.title}
              target="_blank"
              theme="secondary"
              className="mt-32"
              icon={<ArrowRoundedRightup />}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

DesktopMenu.propTypes = {
  mainMenu: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  fixedLinks: PropTypes.shape({
    easyLanguage: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    signLanguage: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    start: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
  onCloseButtonClick: PropTypes.func,
}

DesktopMenu.defaultProps = {
  mainMenu: [],
  tags: [],
  onCloseButtonClick: () => {},
}

export default DesktopMenu
